'use strict';

import 'jquery-mask-plugin/jquery.mask.js';

/**
 * Define input masks
 * @see  http://igorescobar.github.io/jQuery-Mask-Plugin/
 */
$(document).ready(function() {
    var phoneBehavior = function(val) {
            return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
        },
        phoneOptions = {
            onKeyPress: function(val, e, field, options) {
                field.mask(phoneBehavior.apply({}, arguments), options);
            }
        };

    $('.form-mask-phone').mask(phoneBehavior, phoneOptions);
    $('.form-mask-date').mask('00/00/0000');
    $('.form-mask-date-mm-yy').mask('00/00');
    $('.form-mask-date-mm-yyyy').mask('00/0000');
    $('.form-mask-cep').mask('00000-000');
    $('.form-mask-card').mask('0000 0000 0000 0000');
    $('.form-mask-card-valid').mask('00');
    $('.form-mask-card-cvv').mask('0000');
    $('.form-mask-money').mask('#.##0,00', { reverse: true });
    $('.form-mask-cnpj').mask('00.000.000/0000-00', { reverse: true });
    $('.form-mask-cpf').mask('000.000.000-00', { reverse: true });
    $('.form-mask-crm').mask('######0000-AA', { reverse: true }).on('keyup', function(e){
        $(this).val( $(this).val().toUpperCase() );
    });
});



// WEBPACK FOOTER //
// ./src/js/input-mask.js